module.exports = __webpack_public_path__ + "static/img/imgBg.b256d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgBg.png
// module id = jtiA
// module chunks = 3